<div class="login-body">
    <p *ngIf="!currentUser || !currentUser.isLoaded">
        Checking user...
    </p>
    <p *ngIf="currentUser && currentUser.isLoaded && !currentUser.isAuthenticated" class="do-not-use-eips-email-text">
        Need to sign in? Please do not use EIPS emails to sign up.
    </p>
    <a class="sign-in-text" href="DoLogin">Sign in</a>
    <!-- &#64; Will add the @ symbol-->
    <p>If you need assistance, please reach out to: <a
        href="mailto:techsupport@elkislandlocal28.ca">techsupport&#64;elkislandlocal28.ca</a>
        for help</p>
    <p *ngIf="currentUser && currentUser.isLoaded && currentUser.isAuthenticated">
        Signed in as {{ currentUser.firstName }} {{ currentUser.lastName }} ({{ currentUser.email }})
    </p>
</div>
